import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const r = o((c, s) => /* @__PURE__ */ l.jsx(
  h,
  {
    ref: s,
    ...c,
    image: (a) => /* @__PURE__ */ l.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M39.25 16.25h-6.44l4.46-4.46c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-4.46 4.46V8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v6.44l-4.46-4.46a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l4.46 4.46h-6.44c-.41 0-.75.34-.75.75s.34.75.75.75h6.44l-4.46 4.46c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l4.46-4.46v6.44c0 .41.34.75.75.75s.75-.34.75-.75v-6.44l4.46 4.46c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-4.46-4.46h6.44c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M30.09 34.51h-2.18l1.38-1.38c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.38 1.38v-2.18c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.18l-1.38-1.38a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.38 1.38h-2.18c-.41 0-.75.34-.75.75s.34.75.75.75h2.18l-1.38 1.38c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l1.38-1.38v2.18c0 .41.34.75.75.75s.75-.34.75-.75v-2.18l1.38 1.38c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-1.38-1.38h2.18a.749.749 0 1 0 0-1.5M20.51 24.51h-4.07l2.75-2.75c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.75 2.75v-4.07c0-.41-.34-.75-.75-.75s-.75.34-.75.75v4.07l-2.75-2.75a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l2.75 2.75H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h4.07l-2.75 2.75c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l2.75-2.75v4.07c0 .41.34.75.75.75s.75-.34.75-.75v-4.07l2.75 2.75c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06l-2.75-2.75h4.07a.749.749 0 1 0 0-1.5"
          }
        )
      }
    )
  }
));
r.displayName = "AgencySparkleIcon";
export {
  r as AgencySparkleIcon,
  r as default
};
//# sourceMappingURL=index.js.map
